import { TranskodeOptionFrameRate } from "./transkode-option-frame-rate";
import { TranskodeOptionPicture } from "./transkode-option-picture";
import { TranskodeOptionPictureMulti } from "./transkode-option-picture-multi";
import { TranskodeOptionSubtitle } from "./transkode-option-subtitle";
import { TranskodeOptionSubtitleMulti } from "./transkode-option-subtitle-multi";
import { TranskodeOptionAudioMixes } from "./transkode-option-audio-mixes";
import { TranskodeOptionFileFormat } from "./transkode-option-file-format";
import { TranskodeOptionSubtitleFileFormat } from "./transkode-option-subtitle-file-format";
import { TranskodeOptionVideoFieldOrder } from "./transkode-option-video-field-order";
import { TranskodeOptionTimecodeTrim } from "./transkode-option-timecode-trim";
import { TranskodeOptionImageFixed } from "./transkode-option-image-fixed";
import { TranskodeOptionCheckReport } from "./transkode-option-check-report";
import { AmberFinOverlayTextInfos } from "./amber-fin-overlay-text-infos";
import { EditAndConcatCustomEdl } from "./edit-and-concat-custom-edl";
import { VideoFilters } from "./video-filters";

export class TranskodeGenericOptionsProfile {
  frameRate: TranskodeOptionFrameRate | null = null;
  picture: TranskodeOptionPicture | null = null;
  subtitleBurned: TranskodeOptionSubtitle | null = null;
  subtitleSidecarFiles: TranskodeOptionSubtitleMulti | null = null;
  audioMixes: TranskodeOptionAudioMixes | null = null;
  fileFormat: TranskodeOptionFileFormat | null = null;
  fileFormatSubtitleSidecar: TranskodeOptionSubtitleFileFormat | null = null;
  videoFieldOrder: TranskodeOptionVideoFieldOrder | null = null;
  timecodeTrim: TranskodeOptionTimecodeTrim | null = null;
  listTimecodeTrims: TranskodeOptionTimecodeTrim[] | null = null;
  dubbingCards: TranskodeOptionPicture | null = null;
  dubCards: TranskodeOptionPictureMulti | null = null;
  textlessMaterials: TranskodeOptionPicture | null = null;
  restorationCards: TranskodeOptionPicture | null = null;
  imageSidecarFiles: TranskodeOptionImageFixed | null = null;
  checks: TranskodeOptionCheckReport[] | null = null;
  burnTimecode: boolean = false;
  avoidVarispeed: boolean = false;
  doable: boolean = false;
  isAudioOnly: boolean = false;
  overlayTextPlaceholder: string | null = null;
  overlaysText: AmberFinOverlayTextInfos[] | null = null;
  editAndConcatCustomEdl: EditAndConcatCustomEdl | null = null;
  videoFilters: VideoFilters | null = null;
  explodeAudioChannels: boolean = false;
  rewrapOnly: boolean = false;

  constructor(init?: Partial<TranskodeGenericOptionsProfile>) {
    Object.assign(this, init);
  }

  clearValues() {
    if (this.frameRate) {
      const value = Object.assign(new TranskodeOptionFrameRate(), this.frameRate);
      value.clearValues();
      this.frameRate = value;
    }
    if (this.picture) {
      const value = Object.assign(new TranskodeOptionPicture(), this.picture);
      value.clearValues();
      this.picture = value;
    }
    if (this.subtitleBurned) {
      const value = Object.assign(new TranskodeOptionSubtitle(), this.subtitleBurned);
      value.clearValues();
      this.subtitleBurned = value;
    }
    if (this.subtitleSidecarFiles) {
      const value = Object.assign(new TranskodeOptionSubtitleMulti(), this.subtitleSidecarFiles);
      value.clearValues();
      this.subtitleSidecarFiles = value;
    }
    if (this.audioMixes) {
      const value = Object.assign(new TranskodeOptionAudioMixes(), this.audioMixes);
      value.clearValues();
      this.audioMixes = value;
    }
    if (this.fileFormat) {
      const value = Object.assign(new TranskodeOptionFileFormat(), this.fileFormat);
      value.clearValues();
      this.fileFormat = value;
    }
    if (this.fileFormatSubtitleSidecar) {
      const value = Object.assign(new TranskodeOptionSubtitleFileFormat(), this.fileFormatSubtitleSidecar);
      value.clearValues();
      this.fileFormatSubtitleSidecar = value;
    }
    if (this.videoFieldOrder) {
      const value = Object.assign(new TranskodeOptionVideoFieldOrder(), this.videoFieldOrder);
      value.clearValues();
      this.videoFieldOrder = value;
    }
    if (this.dubbingCards) {
      const value = Object.assign(new TranskodeOptionPicture(), this.dubbingCards);
      value.clearValues();
      this.dubbingCards = value;
    }
    if (this.dubCards) {
      const value = Object.assign(new TranskodeOptionPictureMulti(), this.dubCards);
      value.clearValues();
      this.dubCards = value;
    }
    if (this.textlessMaterials) {
      const value = Object.assign(new TranskodeOptionPicture(), this.textlessMaterials);
      value.clearValues();
      this.textlessMaterials = value;
    }
    if (this.restorationCards) {
      const value = Object.assign(new TranskodeOptionPicture(), this.restorationCards);
      value.clearValues();
      this.restorationCards = value;
    }
    if (this.imageSidecarFiles) {
      const value = Object.assign(new TranskodeOptionImageFixed(), this.imageSidecarFiles);
      value.clearValues();
      this.imageSidecarFiles = value;
    }
  }
}
